/**
 * changeVariantDimsImg defines a function that toggles the visibility of image elements with the 'variant-dims-img' data attribute.
 *
 * It selects all elements with that data attribute, then loops through them to check if their data-id matches the provided id parameter.
 *
 * If there is a match, it removes the 'hidden' class from that element to make it visible. If no match, it adds the 'hidden' class to hide that element.
 *
 * It returns an object containing the checkIfCurrentVariantAndToggleVisibility function, so that it can be called later from somewhere else like theme.js.
 */
window.changeVariantDimsImgAndWidth = () => {
  const variantDimImages = document.querySelectorAll('[data-name="variant-dims-img"]');
  const variantDimWidth = document.querySelectorAll('[data-name="variant-dims-value"]');

  const variantWidthMattress = document.querySelector('[data-name="width-mattress-id"]');
  const variantWidth = document.querySelector('[data-name="width-id"]');

  // Check current variant -> start
  const checkIfCurrentVariantAndToggle = (id, variant) => {
    const currentVariant = allVariantMetafields.find(v => v.id === id); //* main-product.liquid

    // Replace omnibus tooltip info -> start ================================================================
    const priceElement = document.querySelector('[data-name="omnibus-sale-price"]');
    if (priceElement) {
      const priceRegex = /:\s*[\p{L}\d\s€$.,ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]+/u;
      const tooltip = priceElement.getAttribute('tooltip');
      const tooltipMatch = tooltip ? tooltip.match(priceRegex) : null;
      if (tooltipMatch) {
        const convertedPrice = currentVariant.convertedOmnibusPrice;
        const newTooltip = priceElement.getAttribute('tooltip').replace(priceRegex, `: ${convertedPrice}`);
        priceElement.setAttribute('tooltip', newTooltip);
      }

    }
    // Replace omnibus tooltip info -> end =================================================================

    // Update product information -> start ==================================================================
    const updateProductInfo = (element, data, processItem) => {
      if (element && data.length > 0) {
        element.innerHTML = data.map(processItem).join('');
      }
    };

    const processListItem = (item) => {
      item = item.trim();
      if (item.includes(':')) {
        const [key, value] = item.split(':');
        return `<li class="wg-translate"><strong>${key.trim()}:</strong> ${value ? value.trim() : ''}</li>`;
      }
      if (item.startsWith('*')) {
        item = item.substring(1).trim();
        return `<li class="wg-translate"><strong class="upper primary">${item}</strong></li>`;
      }
      return `<li class="wg-translate">${item}</li>`;
    };

    // Update specific elements
    updateProductInfo(document.querySelector('[data-name="dimensions-element"]'), currentVariant.dimensions, processListItem);
    updateProductInfo(document.querySelector('[data-name="materials-element"]'), currentVariant.materials, processListItem);
    updateProductInfo(document.querySelector('[data-name="finish-element"]'), currentVariant.finish, processListItem);
    updateProductInfo(document.querySelector('[data-name="relevant-element"]'), currentVariant.relevantInfo, processListItem);

    // Update transparency info
    if (currentVariant.transparency.length > 0) {
      ['materials', 'taxes', 'transport', 'costs'].forEach((item, index) => {
        const element = document.querySelector(`[data-name="${item}-point"]`);
        if (element && currentVariant.transparency[index]) {
          element.textContent = currentVariant.transparency[index];
        }
      });
    }
    // Update product information -> end ==================================================================

    // Replace SKU details info -> start ===================================================================
    const skuElements = [
      document.querySelector('[data-name="details-item-sku"]'),
      document.querySelector('[data-name="dynamic-sku-value"]')
    ];

    skuElements.forEach(element => {
      if (element) {
        element.textContent = currentVariant.sku;
      }
    });
    // Replace SKU details info -> end ====================================================================

    // Replace dimensions -> start ========================================================================
    variantDimImages.forEach((el) => {
      const elId = el.getAttribute("data-id");
      if (elId == id) {
        el.classList.remove("hidden");
      } else {
        el.classList.add("hidden");
      }
    });
    const text = variant.options[0];
    const regex = /^(\d+)/;
    const match = text.match(regex);

    if (match) {
      const firstValue = match[0];
      const result = `${firstValue} cm`;

      if (variantWidthMattress) {
        variantDimWidth.forEach((el) => {
          const elId = el.getAttribute("data-id");
          if (elId == id) {
            variantWidth.textContent = `${el.textContent} cm`;
          }
        });
        variantWidthMattress.textContent = result;
      } else {
        if (variantWidth) {
          variantWidth.textContent = result;
        }
      }
    } else {
      console.log("No match found.");
    }
    // Replace dimensions -> end =========================================================================

    // Metaobject slatsInfo -> start =============================================
    const slatsWidth = document.getElementById('slats-width');
    const slatsWeight = document.getElementById('slats-weight');
    const slatsImage = document.getElementById('slats-image');
    const slatsInfoEmpty = document.getElementById('slats-info-empty');
    const slatsInfoList = document.getElementById('slats-info-list');

    if (
      currentVariant.slatsInfo &&
      (currentVariant.slatsInfo.width || currentVariant.slatsInfo.weight || currentVariant.slatsInfo.image)
    ) {
      if (slatsWidth) slatsWidth.textContent = currentVariant.slatsInfo.width || '';
      if (slatsWeight) slatsWeight.textContent = currentVariant.slatsInfo.weight || '';
      if (slatsImage) {
        const imageUrl = currentVariant.slatsInfo.image || '';
        slatsImage.src = imageUrl;
        slatsImage.style.display = imageUrl ? 'block' : 'none';
      }
      if (slatsInfoEmpty) slatsInfoEmpty.style.display = 'none';
      if (slatsInfoList) slatsInfoList.style.display = 'block';
    } else {
      if (slatsWidth) slatsWidth.textContent = '';
      if (slatsWeight) slatsWeight.textContent = '';
      if (slatsImage) {
        slatsImage.src = '';
        slatsImage.style.display = 'none';
      }
      if (slatsInfoEmpty) slatsInfoEmpty.style.display = 'block';
      if (slatsInfoList) slatsInfoList.style.display = 'none';
    }
    // Metaobject slatsInfo -> end =============================================

    // ! test only -> start
    // setTimeout(() => {
    //   getVariantCsProducts();
    // }, 500);
    // ! test only -> end


    // Replace pairs well with module -> start ===========================================================
    if (document.querySelector('.pairs-well')) {
      async function fetchProductByVariantId(variantId) {
        async function fetchVariantById(variantId) {
          try {
            const response = await fetch(`/variants/${variantId}.json`);
            if (!response.ok) throw new Error('Variant not found');
            const data = await response.json();
            return {
              productId: data.product_variant.product_id,
              variantData: data.product_variant
            };
          } catch (error) {
            console.error(`Error fetching variant ${variantId}:`, error);
            return null;
          }
        }

        const { productId, variantData } = await fetchVariantById(variantId);
        if (!productId) {
          console.error(`No product ID found for variant: ${variantId}`);
          return null;
        }
        try {
          const suggestResponse = await fetch(`/search/suggest.json?q=id:${productId}&resources[type]=product&limit=1`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          });
          if (!suggestResponse.ok) throw new Error('Product handle not found');
          const suggestData = await suggestResponse.json();
          const productHandle = suggestData.resources.results.products[0]?.handle;
          if (!productHandle) {
            console.error(`No product handle found for product ID: ${productId}`);
            return null;
          }
          const productResponse = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
          if (!productResponse.ok) throw new Error('Product not found by handle');
          const productData = await productResponse.json();
          return { productData, variantData };
        } catch (error) {
          console.error(`Error fetching product by ID ${productId}:`, error);
          return null;
        }
      }

      const renderItems = async () => {
        const mainContainerSlider = document.querySelector('.pairs-well');
        mainContainerSlider.innerHTML = '';
        const sliderWrapper = document.createElement('div');
        const sliderWrapperTitle = document.createElement('span');
        sliderWrapper.className = 'pairs-well__wrapper carousel-slider';
        sliderWrapperTitle.textContent = "Pairs well with";
        sliderWrapperTitle.className = 'pairs-well__title black';
        sliderWrapper.style.opacity = 0;
        sliderWrapperTitle.style.opacity = 0;

        const counterPager = document.createElement('div');
        counterPager.classList.add('counter-pager');
        counterPager.style.opacity = 0;

        const currentSlide = document.createElement('span');
        currentSlide.setAttribute('data-name', 'slider-number');

        const slash = document.createElement('span');
        slash.textContent = '/';

        const totalSlides = document.createElement('span');
        totalSlides.setAttribute('data-name', 'slider-number-last');

        counterPager.appendChild(currentSlide);
        counterPager.appendChild(slash);
        counterPager.appendChild(totalSlides);

        if (mainContainerSlider) {
          mainContainerSlider.appendChild(counterPager);
        }

        if (currentVariant.pairsWellWith.length > 1) {
          sliderWrapper.classList.add("pairs-well__wrapper--alt");
          mainContainerSlider.classList.add("pairs-well--slider");
        } else {
          sliderWrapper.classList.remove("pairs-well__wrapper--alt");
          mainContainerSlider.classList.remove("pairs-well--slider");
        }

        mainContainerSlider.appendChild(sliderWrapperTitle);
        mainContainerSlider.appendChild(sliderWrapper);

        const fetchedResults = await Promise.all(
          currentVariant.pairsWellWith.map(variantId => fetchProductByVariantId(variantId))
        );

        fetchedResults.forEach(({ productData, variantData }) => {
          if (productData) {
            function formatPrice(price) {
              let formattedPrice = parseFloat(price).toFixed(2);
              if (formattedPrice.endsWith('.00')) {
                formattedPrice = formattedPrice.slice(0, -3);
              }
              return formattedPrice;
            }

            const item = document.createElement('div');
            item.className = 'pairs-well__item carousel-cell-product';
            item.innerHTML = `
              <a href="${productData.url}" class="pairs-well__item-img" data-product_id="${productData.id}">
                <img src="${productData.featured_image || ''}" alt="${productData.title}" loading="lazy">
              </a>
              <div class="pairs-well__item-title">
                <div class="pairs-well__item-title-info">
                  <a href="${productData.url}" class="truncate-txt" data-product_id="${productData.id}">${productData.title}</a>
                  <p class="pairs-well__item-color truncate-txt">${variantData ? variantData.title : 'No color available'}</p>
                  <price-list class="price-list no-translate-wg">
                  <sale-price class="no-translate-wg ">
                  <span class="sr-only">Sale price</span>
                  <span class="igPrice"
                        data-variant-id="${variantData.id}"
                        data-price="${variantData.price}">
                    ${(() => {
                const formattedPrice = formatPrice(variantData.price);
                switch (variantData.price_currency) {
                  case 'EUR':
                    return `€${formattedPrice}`;
                  case 'CHF':
                    return `CHF ${formattedPrice}`;
                  case 'PLN':
                    return `${formattedPrice} zł`;
                  case 'NOK':
                    return `${formattedPrice} kr`;
                  case 'SEK':
                    return `${formattedPrice} kr`;
                  default:
                    return `${formattedPrice} ${variantData.price_currency}`;
                }
              })()}
                  </span>
                  </sale-price>
                  </price-list>
                </div>
                <button
                  class="button black pairs-well__add-to-cart flex center klaviyo-adc"
                  ${productData.available ? '' : 'style="opacity: 0.4; pointer-events: none;"'}
                  onclick="_addMeToCart(event, this);"
                  data-variant_id="${variantData.id}"
                  data-name="shop-the-look-btn"
                  data-action="open-drawer"
                  data-drawer-id="sidebar-cart"
                  data-flag="Pairs well with"
                >
                  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1 1.73077H4.2934L7.47319 11.4406H16.1041L19 4.74024H16.6435M11.0505 2.28843V4.74024M11.0505 4.74024V7.07855M11.0505 4.74024H13.3871M11.0505 4.74024H8.71388M8.02623 15.5437C8.02623 15.7441 7.86381 15.9065 7.66346 15.9065C7.46311 15.9065 7.30069 15.7441 7.30069 15.5437C7.30069 15.3434 7.46311 15.181 7.66346 15.181C7.86381 15.181 8.02623 15.3434 8.02623 15.5437ZM16.0116 15.5437C16.0116 15.7441 15.8492 15.9065 15.6488 15.9065C15.4485 15.9065 15.2861 15.7441 15.2861 15.5437C15.2861 15.3434 15.4485 15.181 15.6488 15.181C15.8492 15.181 16.0116 15.3434 16.0116 15.5437ZM8.389 15.5437C8.389 15.9444 8.06416 16.2693 7.66346 16.2693C7.26276 16.2693 6.93792 15.9444 6.93792 15.5437C6.93792 15.143 7.26276 14.8182 7.66346 14.8182C8.06416 14.8182 8.389 15.143 8.389 15.5437ZM16.3744 15.5437C16.3744 15.9444 16.0495 16.2693 15.6488 16.2693C15.2481 16.2693 14.9233 15.9444 14.9233 15.5437C14.9233 15.143 15.2481 14.8182 15.6488 14.8182C16.0495 14.8182 16.3744 15.143 16.3744 15.5437Z"
                      stroke="white"
                      stroke-width="1.75"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
            `;
            sliderWrapper.appendChild(item);
          }
        });

        new Flickity(sliderWrapper, {
          freeScroll: false,
          pageDots: true,
          cellAlign: 'left',
          lazyLoad: true,
          wrapAround: false,
          groupCells: true,
          contain: true,
          setGallerySize: true,
          imagesLoaded: true
        });

        setTimeout(() => {
          sliderWrapper.style.opacity = 1;
          sliderWrapperTitle.style.opacity = 1;
          checkSliderReady();
          counterPager.style.opacity = 1;
        }, 220);
      };

      renderItems().catch((error) => {
        console.error('Error while loading products:', error);
      });
    }
    // Replace pairs well with module -> end ===========================================================

    // Omnibus variant module -> start ===========================================================
    function updateOmnibus() {
      const omnibusElement = document.querySelector('.omnibus-price');
      const omnibusValueElement = document.querySelector('[data-name="variant-omnibus-value"]');

      if (!omnibusElement || !omnibusValueElement) return;

      // Use discountBadge from allVariantMetafields (same as badge logic)
      const hasDiscount = currentVariant?.discountBadge?.hasDiscount || false;
      const lowestPriceOmnibus = currentVariant?.omnibusLowestPrice;

      // Hide omnibus if no discount or if lowestPriceOmnibus is 'hidden'
      if (!hasDiscount || lowestPriceOmnibus == 'hidden') {
        omnibusElement.style.display = 'none';
      } else {
        omnibusElement.style.display = '';
        omnibusValueElement.textContent = lowestPriceOmnibus;
      }
    }

    if (document.querySelector('[data-name="variant-omnibus-value"]')) {
      updateOmnibus();
    }
    // Omnibus variant module -> end ===========================================================

    // Shipping time variant module -> start ===========================================================
    if (document.querySelector('[data-name="shipping-info-not-visible-when-stock"]')) {
      const shippingTimeDate = new Date(currentVariant.shippingTimeVariant);
      const shippingTimeValueElement = document.querySelector('[data-name="variant-shipping-time-value"]');
      const shippingTimeDrawer = document.querySelector('[data-name="shipping-time-drawer-content-original"]');
      const deliveryTimeVariant = new Date(currentVariant.deliveryTimeVariant);


      if (shippingTimeDrawer && currentVariant.quantity <= 0) {
        document.querySelectorAll('[data-name="dynamic-shipping-drawer-date-info"]').forEach(element => {
          element.textContent = currentVariant.shippingTime;
        });
      } else {
        document.querySelectorAll('[data-name="dynamic-shipping-drawer-date-info"]').forEach(element => {
          element.textContent = '2 business days';
        });
      }

      // if (shippingTimeValueElement && shippingTimeDate && !currentVariant.preorder && currentVariant.quantity <= 0) {
      //   const currentDate = new Date();
      //   const timeDifference = shippingTimeDate - currentDate;
      //   const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
      //   let shippingInfo = "";
      //   let deliveryInfo = "";

      //   if (daysDifference >= -5 && daysDifference <= 14) {
      //     shippingInfo = "Estimated shipping within 1-2 weeks";
      //     deliveryInfo = "1-2 weeks";
      //   } else if (daysDifference >= 15 && daysDifference <= 21) {
      //     shippingInfo = "Estimated shipping within 2-3 weeks";
      //     deliveryInfo = "2-3 weeks";
      //   } else if (daysDifference >= 22 && daysDifference <= 28) {
      //     shippingInfo = "Estimated shipping within 3-4 weeks";
      //     deliveryInfo = "3-4 weeks";
      //   } else if (daysDifference >= 29 && daysDifference <= 35) {
      //     shippingInfo = "Estimated shipping within 4-5 weeks";
      //     deliveryInfo = "4-5 weeks";
      //   } else if (daysDifference >= 36 && daysDifference <= 42) {
      //     shippingInfo = "Estimated shipping within 5-6 weeks";
      //     deliveryInfo = "5-6 weeks";
      //   } else if (daysDifference >= 43 && daysDifference <= 49) {
      //     shippingInfo = "Estimated shipping within 6-7 weeks";
      //     deliveryInfo = "6-7 weeks";
      //   } else if (daysDifference >= 50 && daysDifference <= 365) {
      //     shippingInfo = "Estimated shipping within 7-8 weeks";
      //     deliveryInfo = "7-8 weeks";
      //   } else {
      //     if (currentVariant.shippingTime) {
      //       shippingInfo = "Estimated shipping within " + currentVariant.shippingTime;
      //     }
      //   }
      //   shippingTimeValueElement.textContent = shippingInfo;
      //   document.querySelectorAll('[data-name="dynamic-shipping-drawer-date-info"]').forEach(element => {
      //     element.textContent = deliveryInfo;
      //   });
      // }

      // ! TEST ONLY -> start
      if (deliveryTimeVariant && !currentVariant.preorder) {
        const deliveryTimeCurrentDate = new Date();
        const deliveryTimeDifference = deliveryTimeVariant - deliveryTimeCurrentDate;
        const deliveryTimeDaysDifference = Math.ceil(deliveryTimeDifference / (1000 * 60 * 60 * 24));
        const deliveryTimeInfo = document.querySelector('[data-name="day-difference"]');
        const deliveryTimeInfoAb = document.querySelector('[data-name="day-difference-ab"]');
        const deliveryDateInfo = document.querySelector('[data-name="delivery-date"]');
        const deliveryIcon = document.querySelector('[data-name="delivery-icon"]');
        const deliveryDaysSum = Number(currentVariant.deliveryDays) + deliveryTimeDaysDifference;

        // Fallback to product shipping time if deliveryTimeVariant is invalid
        let effectiveDeliveryTimeDaysDifference = deliveryTimeDaysDifference;
        let weekRange = null;
        if (isNaN(deliveryTimeDaysDifference) || deliveryTimeDaysDifference < -1000) {
          // Use product shipping time as fallback
          if (currentVariant.shippingTime) {
            // Pass delivery_days to include transport time
            weekRange = getDeliveryRangeFromShippingTime(currentVariant.shippingTime, Number(currentVariant.deliveryDays));
          }
        } else {
          // For out of stock: add delivery_days to get total delivery time
          const totalDeliveryDays = deliveryTimeDaysDifference + Number(currentVariant.deliveryDays);
          weekRange = getDeliveryWeekRangeFromDays(totalDeliveryDays);
        }

        const translations = {
          en: {
            onlyXInStock: (qty, days) => `Only ${qty} in stock - delivery within <span class="translate-wg full-days-span">${days}</span> business days`,
            inStock: (days) => `In stock - delivery within <span class="translate-wg full-days-span">${days}</span> business days`,
            estimatedDelivery: (weeks) => `Estimated delivery within ${weeks}`,
          },
          de: {
            onlyXInStock: (qty, days) => `Nur noch ${qty} auf Lager - Lieferung innerhalb von <span class="translate-wg full-days-span">${days}</span> Werktagen`,
            inStock: (days) => `Auf Lager - Lieferung innerhalb von <span class="translate-wg full-days-span">${days}</span> Werktagen`,
            estimatedDelivery: (weeks) => `Voraussichtliche Lieferung innerhalb von ${weeks}`,
          },
          fr: {
            onlyXInStock: (qty, days) => `Plus que ${qty} en stock - livraison sous <span class="translate-wg full-days-span">${days}</span> jours ouvrés`,
            inStock: (days) => `En stock - livraison sous <span class="translate-wg full-days-span">${days}</span> jours ouvrés`,
            estimatedDelivery: (weeks) => `Livraison estimée sous ${weeks}`,
          },
          pl: {
            onlyXInStock: (qty, days) => `Tylko ${qty} w magazynie - dostawa w ciągu <span class="translate-wg full-days-span">${days}</span> dni roboczych`,
            inStock: (days) => `W magazynie - dostawa w ciągu <span class="translate-wg full-days-span">${days}</span> dni roboczych`,
            estimatedDelivery: (weeks) => `Przewidywany czas dostawy: ${weeks}`,
          }
        };

        const translationsAb = {
          en: {
            onlyXInStock: (qty, days) => `Only ${qty} in stock - delivery in <span class="translate-wg full-days-span">${days - 2}-${days}</span> days`,
            inStock: (days) => `In stock - delivery in <span class="translate-wg full-days-span">${days - 2}-${days}</span> days`,
            estimatedDelivery: (weeks) => `Estimated delivery within ${weeks}`,
          },
          de: {
            onlyXInStock: (qty, days) => `Nur ${qty} auf Lager - Lieferung in <span class="translate-wg full-days-span">${days - 2}-${days}</span> Tagen`,
            inStock: (days) => `Auf Lager - Lieferung in <span class="translate-wg full-days-span">${days - 2}-${days}</span> Tagen`,
            estimatedDelivery: (weeks) => `Voraussichtliche Lieferung innerhalb von ${weeks}`,
          },
          fr: {
            onlyXInStock: (qty, days) => `Seulement ${qty} en stock - livraison sous <span class="translate-wg full-days-span">${days - 2}-${days}</span> jours`,
            inStock: (days) => `En stock - livraison en <span class="translate-wg full-days-span">${days - 2}-${days}</span> jours`,
            estimatedDelivery: (weeks) => `Livraison estimée sous ${weeks}`,
          },
          pl: {
            onlyXInStock: (qty, days) => `Tylko ${qty} w magazynie - dostawa w ciągu <span class="translate-wg full-days-span">${days - 2}-${days}</span> dni`,
            inStock: (days) => `W magazynie - dostawa w ciągu <span class="translate-wg full-days-span">${days - 2}-${days}</span> dni`,
            estimatedDelivery: (weeks) => `Przewidywany czas dostawy: ${weeks}`,
          }
        };

        // Get current language with fallback to English
        const currentLang = Weglot.getCurrentLang();
        const lang = translations[currentLang] ? currentLang : 'en';
        const t = translations[lang];
        const langAb = translationsAb[currentLang] ? currentLang : 'en';
        const tAb = translationsAb[langAb];

        // Set initial delivery info based on stock
        let deliveryShippingInfo = "";
        let deliveryShippingInfoAb = "";
        if (currentVariant.quantity > 0) {
          // For in-stock items, always use 2 days + country delivery days
          const inStockDeliveryDays = 2 + Number(currentVariant.deliveryDays);
          if (currentVariant.quantity <= 10) {
            deliveryShippingInfo = t.onlyXInStock(currentVariant.quantity, inStockDeliveryDays);
            deliveryShippingInfoAb = tAb.onlyXInStock(currentVariant.quantity, inStockDeliveryDays);
            document.querySelectorAll(".shipping-time-icon").forEach(element => {
              element.classList.add("yellow-icon");
            });
            document.querySelectorAll(".shipping-hover-effect").forEach(element => {
              element.style.color = "#9e7606";
            });
          } else {
            deliveryShippingInfo = t.inStock(inStockDeliveryDays);
            deliveryShippingInfoAb = tAb.inStock(inStockDeliveryDays);
            document.querySelectorAll(".shipping-time-icon").forEach(element => {
              element.classList.remove("yellow-icon");
            });
            document.querySelectorAll(".shipping-hover-effect").forEach(element => {
              element.style.color = "#4B8E6D";
            });
          }
          deliveryTimeInfo.querySelector(".wg-translate").innerHTML = deliveryShippingInfo;
          deliveryTimeInfoAb.querySelector(".wg-translate").innerHTML = deliveryShippingInfoAb;
        } else {
          // For out-of-stock items, use the week ranges
          deliveryShippingInfo = t.estimatedDelivery(weekRange);
          deliveryDateInfo.querySelector("span").textContent = deliveryShippingInfo;

          // Reset icon and text color to default (black)
          document.querySelectorAll(".shipping-time-icon").forEach(element => {
            element.classList.remove("yellow-icon");
          });
          document.querySelectorAll(".shipping-hover-effect").forEach(element => {
            element.style.color = "";
          });
        }

        if (currentVariant.quantity > 0) {
          deliveryTimeInfo.classList.remove("hidden");
          deliveryDateInfo.classList.add("hidden");
        } else {
          deliveryTimeInfo.classList.add("hidden");
          deliveryDateInfo.classList.remove("hidden");
        }
      }
      // ! TEST ONLY -> end
    }
    // Shipping time variant module -> end ===========================================================

    // Current image test-> start ===========================================================
    // const currentVariantImage = currentVariant.image;
    // const variantGallery = document.querySelector('[data-name="variant-gallery"]');
    // if (currentVariantImage && variantGallery) {
    //   const variantImg = document.createElement('img');
    //   variantImg.src = currentVariantImage;
    //   variantImg.style.maxWidth = '200px';
    //   variantGallery.innerHTML = '';
    //   variantGallery.appendChild(variantImg);
    // }
    // const currentVariantSku = currentVariant.sku.replace(/\./g, '')

    // currentVariant.productImages.forEach(image => {
    //   if (image.includes(currentVariantSku)) {
    //     console.log('Matching variant image:', image);
    //     const productImg = document.createElement('img');
    //     productImg.src = image;
    //     productImg.style.maxWidth = '200px';
    //     productImg.classList.add('product-gallery-image');
    //     variantGallery.appendChild(productImg);
    //   }
    // });
    // Current image test-> end ===========================================================
  };
  return { checkIfCurrentVariantAndToggle }; // Return an object with the function so that it can be used later (theme.js)
};
// Check current variant -> end

function getCurrentWidth() {
  const variantWidthMattress = document.querySelector('[data-name="width-mattress-id"]') ? document.querySelector('[data-name="width-mattress-id"]').textContent : null;
  if (variantWidthMattress) {
    const id = (window.location.href.match(/variant=(\d+)/) || [null, null])[1];
    fetch(`${window.Shopify.routes.root}variants/${id}.js`)
      .then(response => response.json())
      .then(data => {
        const result = data.option1.match(/^\d+/) + " cm";
        document.querySelector('[data-name="width-mattress-id"]').textContent = result;
      })
      .catch(error => console.error(error));
  }
}
getCurrentWidth();

// === UNIFIED DELIVERY RANGE LOGIC (checkout style) ===
function getMaxWeeksFromRange(weeksString) {
  if (!weeksString || typeof weeksString !== "string") return null;
  // Obsługuje "2-3 weeks", "3 weeks", "2 tygodnie", "2-3 tygodnie"
  const match = weeksString.match(/(\d+)(?:\s*-\s*(\d+))?\s*(week|tydzień|tygodni|weeks)?/i);
  if (match) {
    if (match[2]) {
      return parseInt(match[2], 10);
    } else {
      return parseInt(match[1], 10);
    }
  }
  return null;
}

function getDeliveryWeekRangeFromDays(days) {
  if (days >= 1 && days <= 14) return "1-2 weeks";
  if (days >= 15 && days <= 21) return "2-3 weeks";
  if (days >= 22 && days <= 28) return "3-4 weeks";
  if (days >= 29 && days <= 35) return "4-5 weeks";
  if (days >= 36 && days <= 42) return "5-6 weeks";
  if (days >= 43 && days <= 49) return "6-7 weeks";
  return "7-8 weeks";
}

function getDeliveryRangeFromShippingTime(shippingTimeString, deliveryDays) {
  // Jeśli to data (YYYY-MM-DD)
  if (/^\d{4}-\d{2}-\d{2}$/.test(shippingTimeString)) {
    const [year, month, day] = shippingTimeString.split('-').map(Number);
    const today = new Date();
    const deliveryDate = new Date(Date.UTC(year, month - 1, day + 2)); // +2 dni jak w Twojej logice
    let daysDiff = Math.ceil((deliveryDate - today) / (1000 * 60 * 60 * 24));
    // Add delivery_days for total delivery time
    daysDiff = daysDiff + deliveryDays;
    return getDeliveryWeekRangeFromDays(daysDiff);
  }
  // Jeśli zakres tygodniowy
  const maxWeeks = getMaxWeeksFromRange(shippingTimeString);
  if (maxWeeks) {
    const today = new Date();
    const deliveryDate = new Date(today);
    deliveryDate.setDate(today.getDate() + maxWeeks * 7);
    let daysDiff = Math.ceil((deliveryDate - today) / (1000 * 60 * 60 * 24));
    // Add delivery_days for total delivery time
    daysDiff = daysDiff + deliveryDays;
    return getDeliveryWeekRangeFromDays(daysDiff);
  }
  // Fallback: jeśli nie rozpoznano formatu, domyślnie 3-4 tygodnie
  return "3-4 weeks";
}